import React, { useState, useEffect } from 'react'
import styles from './styles.module.css'
import { useForm } from 'react-hook-form'
import { useQuery, useMutation } from 'react-query'
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js'
import LinearProgress from '@material-ui/core/LinearProgress'
import CircularProgress from '@mui/material/CircularProgress'
import { getAccount, postEditBilling } from '../../../../../Api/index'
// import BaseAlert from '../../Snackbar/NewImplementations/BaseAlert/BaseAlert'
import BaseAlert from '../../../../Snackbar/NewImplementations/BaseAlert/BaseAlert'

function PaymentSettings () {
  const [cardState, setCardState] = useState(false)
  const [readyCard, setReadyCard] = useState(false)
  const [loadingStripe, setLoadingStripe] = useState(false)
  const [setSnackMessage] = useState({ type: 'error' })
  const [alert, setAlert] = useState({
    open: false,
    title: '',
    body: '',
    color: '#48B966',
    actions: []
  })

  const { data: customerAccount } = useQuery('SecondFormAccount', getAccount)
  const elements = useElements()
  const stripe = useStripe()

  const [formData, setFormData] = useState({
    cardHolderName: '',
    address: '',
    city: '',
    state: '',
    postalCode: ''
  })

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({ mode: 'onSubmit' })

  const [updateBilling, { isLoading }] = useMutation(
    ({ userData }) => postEditBilling(userData),
    { onSuccess: handleSuccess, onError: handleError }
  )

  function handleSuccess (data) {
    const { status, data: result } = data
    if (status >= 400) {
      setSnackMessage({
        type: 'error',
        myMessage: result.errors,
        update: Date.now()
      })
      setLoadingStripe(false)
    } else {
      // show success base alert
      setAlert({
        open: true,
        title: 'Billing information updated',
        body: 'Refresh the page to see the changes.',
        color: '#48B966',
        actions: [
          {
            label: 'Ok',
            onClick: () => {
              setAlert(a => ({ ...a, open: false }))
              setTimeout(() => window.location.reload(), 300)
            }
          }
        ]
      })

      //   setTimeout(() => {
      //     window.location.reload()
      //   }, 1000)
    }
  }

  function handleError (error) {
    const code = error.response?.data?.errors?.code
    const message = code
      ? `Error – ${code}`
      : 'Something has happened. Please contact customer support'
    setSnackMessage({
      type: 'error',
      myMessage: message,
      update: Date.now()
    })
    setLoadingStripe(false)
  }

  const onClickUpdateBilling = async () => {
    setLoadingStripe(true)
    if (!stripe || !elements) return

    const cardElement = elements.getElement(CardElement)
    const { error, token } = await stripe.createToken(cardElement, {
      name: formData.cardHolderName,
      address_line1: formData.address,
      address_city: formData.city,
      address_state: formData.state,
      address_zip: formData.postalCode
    })

    if (error) {
      setSnackMessage({
        type: 'error',
        myMessage: error.message,
        update: Date.now()
      })
      setLoadingStripe(false)
      return
    }

    updateBilling({
      userData: {
        source: token.id,
        customer: customerAccount?.data?.customer_id
      }
    })
  }

  useEffect(() => {
    if (customerAccount?.data) {
      setFormData(prev => ({ ...prev }))
    }
  }, [customerAccount])

  return (
    <div className={styles.PaymentSettingsContainer}>
      <h1 className={styles.PaymentSettingsTitle}>Payment Information</h1>
      <form autoComplete='off' onSubmit={handleSubmit(onClickUpdateBilling)}>
        <label className={styles.CardHolderNameLabel}>Cardholder name</label>
        <input
          autoComplete='off'
          className={styles.inputCardHolderName}
          type='text'
          {...register('cardHolderName', {
            required: 'Cardholder is required',
            onChange: e =>
              setFormData({ ...formData, cardHolderName: e.target.value })
          })}
        />
        {errors.cardHolderName && <span>Name is required</span>}

        <label className={styles.AddressLabel}>Address</label>
        <input
          autoComplete='off'
          className={styles.inputAddress}
          type='text'
          {...register('address', {
            required: 'Address is required',
            onChange: e => setFormData({ ...formData, address: e.target.value })
          })}
        />
        {errors.address && <span>Address is required</span>}

        <label className={styles.CityLabel}>City</label>
        <input
          autoComplete='off'
          className={styles.inputCity}
          type='text'
          {...register('city', {
            required: 'City is required',
            onChange: e => setFormData({ ...formData, city: e.target.value })
          })}
        />
        {errors.city && <span>City is required</span>}

        <label className={styles.StateLabel}>State</label>
        <input
          autoComplete='off'
          className={styles.inputState}
          type='text'
          {...register('state', {
            required: 'State is required',
            onChange: e => setFormData({ ...formData, state: e.target.value })
          })}
        />
        {errors.state && <span>State is required</span>}

        <label className={styles.PostalCodeLabel}>Zip Code</label>
        <input
          autoComplete='off'
          className={styles.inputPostalCode}
          type='text'
          {...register('postalCode', {
            required: 'Postal Code is required',
            onChange: e =>
              setFormData({ ...formData, postalCode: e.target.value })
          })}
        />
        {errors.postalCode && <span>Postal Code is required</span>}

        <div style={{ marginBottom: '12px' }}>
          <CardElement
            onReady={el => setReadyCard(!!el)}
            onChange={e => setCardState(e.complete)}
            options={{
              style: { base: { fontFamily: 'Roboto', fontSize: '16px' } },
              hidePostalCode: true
            }}
          />
          {!readyCard && (
            <LinearProgress style={{ marginTop: '5px', height: '5px' }} />
          )}
        </div>

        {isLoading ? (
          <button className={styles.spinnerDisabled}>
            <CircularProgress
              style={{ width: '25px', height: '30px', color: 'white' }}
            />
          </button>
        ) : (
          <button
            disabled={!cardState || loadingStripe}
            className={styles.UpdateButtonPaymentSettings}
            type='submit'
          >
            Update
          </button>
        )}
      </form>

      {/* <ModalSettings open={open} onClose={handleClose} /> */}

      {/* <SnackbarComponent snackData={snackMessage} /> */}

      <BaseAlert
        open={alert.open}
        title={alert.title}
        body={alert.body}
        color={alert.color}
        style={{ width: '320px' }}
        actions={alert.actions}
        onClose={() => {
          setAlert(a => ({ ...a, open: false }))
          setTimeout(() => window.location.reload(), 300)
        }}
      />
    </div>
  )
}

export default PaymentSettings
